import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { AppProvider } from '../context/AppContext';
import CadastroScreen from './CadastroScreen';

function LoadingCard({ message }) {
  return (
    <div style={{
      background: 'var(--bg-surface)',
      border: '1px solid var(--action-border)',
      borderRadius: 0,
      padding: 32,
      width: '100%',
      maxWidth: 520,
      color: 'var(--text-primary)'
    }}>
      <h1 style={{ fontSize: 24, margin: '0 0 8px' }}>Convite iafm.io</h1>
      <p style={{ color: 'var(--text-secondary)', margin: 0 }}>{message}</p>
    </div>
  );
}

function InviteShell({ children }) {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg-base)',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      padding: '32px 20px',
      boxSizing: 'border-box'
    }}>
      <div style={{ width: '100%', maxWidth: 760 }}>
        {children}
      </div>
    </div>
  );
}

function InviteHeader({ invite }) {
  return (
    <div style={{
      background: 'var(--bg-surface)',
      border: '1px solid var(--action-border)',
      borderRadius: 0,
      padding: 24,
      marginBottom: 20
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap' }}>
        <div>
          <h1 style={{ color: 'var(--text-primary)', fontSize: 26, margin: '0 0 8px' }}>
            Cadastro por convite
          </h1>
          <p style={{ color: 'var(--text-secondary)', margin: 0, lineHeight: 1.5 }}>
            Este link autoriza a criação de uma conta. Ele não ativa runtime, player ou fluxo semântico automaticamente.
          </p>
        </div>
        <Link
          to="/login"
          style={{
            color: 'var(--brand-400)',
            textDecoration: 'none',
            fontWeight: 600,
            alignSelf: 'flex-start'
          }}
        >
          Entrar
        </Link>
      </div>

      {invite?.expiresAt && (
        <div style={{
          marginTop: 16,
          paddingTop: 16,
          borderTop: '1px solid rgba(var(--neutral-300-rgb),0.35)',
          color: 'var(--text-muted)',
          fontSize: 13
        }}>
          Expira em {new Date(invite.expiresAt).toLocaleString('pt-BR')}
          {invite.emailLocked && invite.emailHint ? ` · Email vinculado: ${invite.emailHint}` : ''}
        </div>
      )}
    </div>
  );
}

function InviteSignupContent({ token }) {
  const [state, setState] = useState({ loading: true, valid: false, invite: null, message: '' });

  useEffect(() => {
    let cancelled = false;

    async function validate() {
      if (!token) {
        setState({ loading: false, valid: false, invite: null, message: 'Convite ausente.' });
        return;
      }

      setState(prev => ({ ...prev, loading: true }));
      try {
        const res = await fetch(`/api/auth/signup-invites/validate?token=${encodeURIComponent(token)}`);
        const data = await res.json().catch(() => ({}));
        if (cancelled) return;

        if (!res.ok || !data.valid) {
          setState({
            loading: false,
            valid: false,
            invite: data.invite || null,
            message: data.message || 'Convite inválido ou expirado.'
          });
          return;
        }

        setState({ loading: false, valid: true, invite: data.invite, message: '' });
      } catch {
        if (!cancelled) {
          setState({ loading: false, valid: false, invite: null, message: 'Erro de conexão ao validar convite.' });
        }
      }
    }

    validate();
    return () => { cancelled = true; };
  }, [token]);

  if (state.loading) {
    return <LoadingCard message="Validando convite..." />;
  }

  if (!state.valid) {
    return (
      <LoadingCard message={state.message || 'Convite inválido ou expirado.'} />
    );
  }

  return (
    <>
      <InviteHeader invite={state.invite} />
      <AppProvider>
        <CadastroScreen signupInviteToken={token} publicInviteMode />
      </AppProvider>
    </>
  );
}

export default function InviteSignupScreen() {
  const { token } = useParams();
  const [storageReady, setStorageReady] = useState(false);

  useEffect(() => {
    localStorage.removeItem('radio-ai-user');
    localStorage.removeItem('radio-ai-jwt');
    setStorageReady(true);
  }, [token]);

  return (
    <InviteShell>
      {storageReady
        ? <InviteSignupContent token={token} />
        : <LoadingCard message="Preparando cadastro..." />}
    </InviteShell>
  );
}
